import { useRef } from 'react';

/**
 * Returns a ref that always points to the latest value.
 * Syncs during render (not via useEffect), eliminating the need
 * for the `useRef` + `useEffect` pattern repeated throughout the codebase.
 */
export function useLatest<T>(value: T): React.MutableRefObject<T> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
